import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { isLocalStorageEnabled } from 'Lib/is-local-storage-enabled/is-local-storage-enabled';
import { oLike } from 'Lib/like/like';
import { getCookie } from 'Lib/cookies/cookies';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/collections-slider/collections-slider';
import 'Bem/site/spoiler/spoiler';
import 'Bem/site/book/book';
import 'Bem/site/corp-form/corp-form';
import 'Bem/site/reviews/reviews';
import 'Bem/site/form-bg/form-bg';
import 'Bem/site/tabs/tabs';
import 'Bem/site/copy/copy';
import 'Bem/site/content-slider/content-slider';
import 'Bem/site/checkbox/checkbox';
import 'Bem/site/audio-play/audio-play';
import 'Bem/site/multiple-file-upload/multiple-file-upload';
import 'Bem/site/book3d/book3d';
import 'Bem/site/book-page/book-page';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/livelib-rating/livelib-rating';
import 'Bem/site/video-reviews/video-reviews';
import 'Bem/site/collection-management/collection-management';
import 'Bem/site/sales-book/sales-book';
import 'Bem/site/popup-promocode/popup-promocode';
import 'Bem/site/book-preview/book-preview';
import { PopupVideo } from 'Lib/popup/popup-video';
import 'Bem/site/will-read/will-read';
import { Reactions } from 'Lib/reactions/reactions';
import { oLikeDislike } from 'Lib/like-dislike/like-dislike';

window.addEventListener('load', () => {
    import('Bem/site/popup-subscribe/popup-subscribe');
    import('Bem/site/sales-main/sales-main');
});

const popupVideo = new PopupVideo();
const $bookPage = $('.book-page');
const $body = $('body');
let reactions = new Reactions(document.querySelectorAll('.reactions'));

popupVideo.popupVideoOpenDefault();
svgSpriteLoader('/site/book/svg/sprite.svg?v=20180320');
oLike.init('.js-book-like, .js-like');
oLikeDislike.init('.js-like-dislike');

$body.on('eksmoPagenavAjax', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
    oLikeDislike.init('.js-like-dislike');
}).on('like.eksmo', () => {
    oLike.init('.js-book-like, .js-like');
});

$body.on('bitrixDynamicComposite.eksmo', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
});

window.addEventListener('load', () => {
    import('Bem/site/photogallery-slider/photogallery-slider');
});

// Записываем в LocalStorage просмотренную книгу (используется для блока на главной "Вы смотрели"),
// взаимодействие с этим LocalStorage здесь - \eksmo\source\bem\site\buy-now\buy-now.js
$(window).on('load', () => {
    if (isLocalStorageEnabled() && !$('.book-page__card').find('.prices-card__na').length) {
        const nomcode = $bookPage.attr('data-book-id');
        const booksViewed = JSON.parse(localStorage.getItem('booksViewed'));

        if (booksViewed && getCookie('EKSMO_BOOKS_VIEWED') === 'Y') {
            if (!booksViewed.some((el) => el === nomcode)) {
                if (booksViewed.length === 30) { // ограничение на количество сохраняемых книг
                    booksViewed.pop();
                }

                booksViewed.unshift(nomcode);
                localStorage.setItem('booksViewed', JSON.stringify(booksViewed));
            }
        } else {
            const date = new Date(new Date().getTime() + 60 * 1000 * 60 * 24 * 30); // на 30 дней

            localStorage.removeItem('booksViewed');
            document.cookie = `EKSMO_BOOKS_VIEWED=Y; path=/; domain=${window.location.hostname}; expires=${date.toUTCString()}; SameSite=None; Secure`;
            localStorage.setItem('booksViewed', JSON.stringify([nomcode]));
        }
    }
});